module.exports = __webpack_public_path__ + "img/greengrass3.ae594ac0.jpg";